<div class="card p-4">
  <div class="card-content">
    <h3 *ngIf="!displayNoPermissionMsg">We are logging you in.</h3>
    <p *ngIf="!displayNoPermissionMsg">
      Please wait while we set up your permissions.
    </p>
    <p *ngIf="displayNoPermissionMsg">
      We weren't able to log you in. Please contact your manager to get
      permissions.
    </p>
  </div>
</div>
